import { render } from "./quote-breakdown.vue?vue&type=template&id=e2b82baa&scoped=true"
import script from "./quote-breakdown.vue?vue&type=script&lang=js"
export * from "./quote-breakdown.vue?vue&type=script&lang=js"

import "./quote-breakdown.vue?vue&type=style&index=0&id=e2b82baa&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2b82baa"]])

export default __exports__